export enum ReturnabilityIndicator {
    Yes = "Yes",
    No = "No",
    FullPackageQuantity = "FullPackageQuantity",
}
